import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const offlineFlag = String(process.env.REACT_APP_OFFLINE_MODE || '').toLowerCase() === 'true';

function createOfflineSupabase() {
  const readJson = (key) => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; }
  };
  const writeJson = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
  };

  const tableApi = (tableName) => ({
    select: () => ({
      order: (_col, { ascending } = { ascending: false }) => {
        const data = readJson(tableName).slice().sort((a, b) => {
          const at = new Date(a.created_at || 0).getTime();
          const bt = new Date(b.created_at || 0).getTime();
          return ascending ? at - bt : bt - at;
        });
        return Promise.resolve({ data, error: null });
      }
    }),
    insert: (rows) => {
      const list = readJson(tableName);
      const now = new Date().toISOString();
      const withIds = rows.map((r) => ({ id: r.id || `temp-${crypto.randomUUID?.() || Math.random().toString(36).slice(2)}`, created_at: r.created_at || now, ...r }));
      const data = [...withIds, ...list];
      writeJson(tableName, data);
      return Promise.resolve({ data: withIds, error: null });
    },
    update: (row) => ({
      eq: (col, val) => {
        const list = readJson(tableName);
        const data = list.map((r) => (r[col] === val ? { ...r, ...row } : r));
        writeJson(tableName, data);
        const updated = data.find((r) => r[col] === val);
        return Promise.resolve({ data: updated ? [updated] : [], error: null });
      }
    }),
    delete: () => ({
      eq: (col, val) => {
        const list = readJson(tableName);
        const data = list.filter((r) => r[col] !== val);
        writeJson(tableName, data);
        return Promise.resolve({ data: null, error: null });
      }
    })
  });

  return {
    _offline: true,
    channel: () => ({ subscribe: () => ({ unsubscribe: () => {} }) }),
    removeChannel: () => {},
    from: (name) => tableApi(name),
    storage: {
      from: () => ({
        upload: async () => ({ data: { path: '' }, error: null }),
        remove: async () => ({ data: null, error: null }),
        getPublicUrl: () => ({ data: { publicUrl: '' } })
      })
    },
    auth: {
      getUser: async () => ({ data: { user: null }, error: null }),
      onAuthStateChange: (_cb) => ({ data: { subscription: { unsubscribe: () => {} } } }),
      signUp: async () => ({ data: { user: { id: 'offline' } }, error: null }),
      signInWithPassword: async () => ({ data: { user: { id: 'offline' } }, error: null }),
      signOut: async () => ({ error: null })
    }
  };
}

export const isOffline = offlineFlag || !supabaseUrl || !supabaseKey;
export const supabase = isOffline ? createOfflineSupabase() : createClient(supabaseUrl, supabaseKey);